import { render } from "./TriggeringElement.vue?vue&type=template&id=8bbf6768"
import script from "./TriggeringElement.vue?vue&type=script&lang=js"
export * from "./TriggeringElement.vue?vue&type=script&lang=js"

import "./TriggeringElement.vue?vue&type=style&index=0&id=8bbf6768&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__